export default "__VITE_ASSET__GB2ACiKa__"